import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Reserver from "@/pages/Reserver";
import Galerie from "@/pages/Galerie";
import Legal from "@/pages/Legal";
import Jouer from "@/pages/Jouer";
import JouerGame from "@/pages/JouerGame";
import Producteurs from "@/pages/Producteurs";
import Compte from "@/pages/Compte";

import DashboardLayout from "@/components/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Sessions from "@/pages/dashboard/Sessions";
import ParcoursPage from "@/pages/dashboard/Parcours";
import Reservations from "@/pages/dashboard/Reservations";
import Partenaires from "@/pages/dashboard/Partenaires";
import Produits from "@/pages/dashboard/Produits";
import Communaute from "@/pages/dashboard/Communaute";
import Finances from "@/pages/dashboard/Finances";
import IaBuilder from "@/pages/dashboard/IaBuilder";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/reserver" element={<Reserver />} />
          <Route path="/producteurs" element={<Producteurs />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/compte" element={<Compte />} />
          <Route path="/legal/mentions-legales" element={<Legal section="mentions-legales" />} />
          <Route path="/legal/cgv" element={<Legal section="cgv" />} />
          <Route path="/legal/confidentialite" element={<Legal section="confidentialite" />} />

          {/* Joueur */}
          <Route path="/jouer" element={<Jouer />} />
          <Route path="/jouer/:code" element={<JouerGame />} />

          {/* Dashboard (protected) */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Overview />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="parcours" element={<ParcoursPage />} />
            <Route path="reservations" element={<Reservations />} />
            <Route path="partenaires" element={<Partenaires />} />
            <Route path="produits" element={<Produits />} />
            <Route path="communaute" element={<Communaute />} />
            <Route path="finances" element={<Finances />} />
            <Route path="ia-builder" element={<IaBuilder />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
